"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupRoleBranchPresenterImpl = void 0;
const vue_1 = require("vue");
const branch_1 = require("../subject/branch");
const groupRoleBranch_1 = require("../subject/groupRoleBranch");
const roles_1 = require("../js/roles");
class GroupRoleBranchPresenterImpl {
    viewModel;
    groupRoleBranchObserver;
    branchObserver;
    originallySelectedBranchIds = (0, vue_1.ref)(new Set());
    isGroupOwner;
    constructor(viewModel, groupRoleBranchObs, branchObs, isGroupOwner) {
        this.viewModel = viewModel;
        this.groupRoleBranchObserver = groupRoleBranchObs;
        this.branchObserver = branchObs;
        this.isGroupOwner = isGroupOwner;
        this.branchObserver.getEventListener().addEventListener(branch_1.BranchSubjectEventTypes.ADD, (e) => this.handleBranchAdd(e.detail.value));
        this.groupRoleBranchObserver.getEventListener().addEventListener(groupRoleBranch_1.GroupRoleBranchEventTypes.ADD, (e) => this.handleGroupRoleBranchAdd(e.detail.value));
        this.groupRoleBranchObserver.getEventListener().addEventListener(groupRoleBranch_1.GroupRoleBranchEventTypes.UPDATE, (e) => this.handleGroupRoleBranchUpdate(e.detail.value));
    }
    branchViewFromModel(branch) {
        return {
            id: branch.id,
            name: branch.name,
        };
    }
    handleOpenModal(roleId) {
        const groupRoleBranch = this.groupRoleBranchObserver.getState().find(r => r.id === roleId);
        const branchIds = groupRoleBranch?.branchIds || [];
        this.originallySelectedBranchIds.value = new Set(branchIds);
        this.viewModel.selectedBranchIds = new Set(branchIds);
        this.setFilteredBranches();
        this.setPaginatedBranches();
        this.viewModel.roleId = roleId;
        this.viewModel.isVisible = true;
    }
    handleCloseModal() {
        this.viewModel.isVisible = false;
        this.viewModel.selectedBranchIds.clear();
        this.originallySelectedBranchIds.value.clear();
        this.viewModel.branchIdsToAdd.clear();
        this.viewModel.branchIdsToRemove.clear();
        this.viewModel.currentPage = 1;
        this.viewModel.searchInput = "";
    }
    handleSetIsLoading(value) {
        this.viewModel.isLoading = value;
    }
    handleBranchAdd(branch) {
        const isOwner = branch.ownerIds.includes(this.viewModel.userId) || this.isGroupOwner;
        const isAlreadyAdded = this.viewModel.allBranchesMap.has(branch.id);
        if (branch.groupId !== this.viewModel.groupId || !isOwner || isAlreadyAdded) {
            return;
        }
        this.viewModel.allBranchesMap.set(branch.id, this.branchViewFromModel(branch));
    }
    handleGroupRoleBranchAdd(groupRoleBranch) {
        this.updateActiveBranchCounts(groupRoleBranch.id, groupRoleBranch.branchIds.length);
        if (!this.viewModel.isGroupSectionPage) {
            // Set branch count in the roles table
            (0, roles_1.setActiveBranchCountForRole)(groupRoleBranch.id, groupRoleBranch.branchIds.length);
        }
        if (groupRoleBranch.id !== this.viewModel.roleId) {
            return;
        }
        this.originallySelectedBranchIds.value = new Set(groupRoleBranch.branchIds);
        this.viewModel.selectedBranchIds = new Set(groupRoleBranch.branchIds);
    }
    handleGroupRoleBranchUpdate(groupRoleBranch) {
        if (groupRoleBranch.id !== this.viewModel.roleId) {
            return;
        }
        this.originallySelectedBranchIds.value = new Set(groupRoleBranch.branchIds);
        this.viewModel.selectedBranchIds = new Set(groupRoleBranch.branchIds);
    }
    handleBranchSelect(branchId) {
        const wasOriginallySelected = this.originallySelectedBranchIds.value.has(branchId);
        // Branch was deselected
        if (this.viewModel.selectedBranchIds.has(branchId)) {
            this.viewModel.selectedBranchIds.delete(branchId);
            this.viewModel.branchIdsToAdd.delete(branchId);
            // Remove if it was originally selected
            if (wasOriginallySelected) {
                this.viewModel.branchIdsToRemove.add(branchId);
            }
        }
        else { // Branch was selected
            this.viewModel.selectedBranchIds.add(branchId);
            this.viewModel.branchIdsToRemove.delete(branchId);
            // Add if it wasn’t originally selected
            if (!wasOriginallySelected) {
                this.viewModel.branchIdsToAdd.add(branchId);
            }
        }
    }
    updateBranchesToEdit() {
        const selected = this.viewModel.selectedBranchIds; // Currently selected branches
        const original = this.originallySelectedBranchIds.value; // Originally selected branches
        const toAdd = new Set();
        const toRemove = new Set();
        for (const id of selected) {
            if (!original.has(id)) {
                toAdd.add(id);
            }
        }
        for (const id of original) {
            if (!selected.has(id)) {
                toRemove.add(id);
            }
        }
        this.viewModel.branchIdsToAdd = toAdd;
        this.viewModel.branchIdsToRemove = toRemove;
    }
    handleClearBranches() {
        // Remove filtered branches
        for (const id of this.viewModel.filteredBranchIds) {
            this.viewModel.selectedBranchIds.delete(id);
        }
        this.updateBranchesToEdit();
    }
    handleSelectAllFilteredBranches() {
        // Add filtered branches
        for (const id of this.viewModel.filteredBranchIds) {
            this.viewModel.selectedBranchIds.add(id);
        }
        this.updateBranchesToEdit();
    }
    handleUpdatePage(currentPage) {
        this.viewModel.currentPage = currentPage;
        this.setPaginatedBranches();
    }
    setPaginatedBranches() {
        if (!this.viewModel.allBranchesMap || this.viewModel.allBranchesMap.size === 0) {
            this.viewModel.paginatedBranchIds = [];
            this.viewModel.filteredBranchIds.clear();
            return;
        }
        const filtered = [...this.viewModel.filteredBranchIds];
        const start = (this.viewModel.currentPage - 1) * this.viewModel.dataPerPage;
        this.viewModel.paginatedBranchIds = filtered.slice(start, start + this.viewModel.dataPerPage);
    }
    setFilteredBranches() {
        const searchTerm = this.viewModel.searchInput?.trim().toLowerCase();
        const filtered = new Set();
        for (const [id, branch] of this.viewModel.allBranchesMap.entries()) {
            if (!searchTerm || branch.name.toLowerCase().includes(searchTerm)) {
                filtered.add(id);
            }
        }
        this.viewModel.filteredBranchIds = filtered;
    }
    handleOpenSearchBar() {
        this.viewModel.isSearchBarOpen = true;
    }
    handleCloseSearchBar() {
        this.viewModel.isSearchBarOpen = false;
    }
    handleSetSearchInput(input) {
        this.viewModel.searchInput = input;
        this.setFilteredBranches();
    }
    updateActiveBranchCounts(roleId, activeBranchCount) {
        if (activeBranchCount === undefined) {
            const groupRoleBranch = this.groupRoleBranchObserver.getState().find(r => r.id === roleId);
            activeBranchCount = groupRoleBranch?.branchIds.length || 0;
        }
        const total = this.viewModel.allBranchesMap?.size || activeBranchCount;
        let label = "全拠点";
        if (activeBranchCount !== total || total <= 0) {
            label = activeBranchCount > 0 ? String(activeBranchCount) : "なし";
        }
        this.viewModel.activeBranchCounts.set(roleId, label);
    }
}
exports.GroupRoleBranchPresenterImpl = GroupRoleBranchPresenterImpl;
